<template>
  <div class="container">
    <div class="section-title" style="text-align: center; margin-top: 40px;">
      Bony podarunkowe
    </div>
    <div class="gifts">
      <!-- <path-navigation
        :paths="[{ name: 'Bony podarunkowe', to: '/vouchery' }]"
      /> -->

      <section class="giftForSomeone">
        <div class="sub-title ">Spraw komuś prezent!</div>

        <div class="card-container">
          <div v-for="giftCard in giftCards" :key="giftCard.id">
            <GiftCard
              :giftCard="giftCard"
              :basicPrice="giftCards[0] ? giftCards[0].price : null"
            />
          </div>
        </div>
      </section>
      <section class="howItWorks" style="margin-top: 100px;">
        <h2 class="sub-title">Jak to działa?</h2>
        <ol>
          <li class="pb-1">
            Kupując subskrypcje dostajesz na maila voucher z unikalnym kodem
          </li>
          <li>
            W celu wykorzystania kodu, po zarejestrowaniu należy wejść w opcję
            “voucher podarunkowy” a następnie wpisać kod.
          </li>
        </ol>
      </section>
      <section class="whatGivesSubscription">
        <h2 class="sub-title">Co daje subskrypcja?</h2>
        <p>
          Wykupując subskrypcję, otrzymujesz pełen dostęp do wszystkich grup
          praktyk: docelowych, uzupełniających, praktyki dla początkujących,
          analizy asan, oddechu i medytacji.
        </p>
        <p>
          Każdego miesiąca są dodawane dwie nowe praktyki: jedna na początku
          miesiąca, druga w jego połowie. Praktyki są pełnowartościowe, z jasnym
          przekazem. Sekwencje zawierają równeiż modyfikacje trudniejszych asan,
          które możesz dostosować do swojego poziomu i samopoczucia.
        </p>
        <p>
          Praktyki są ułożone z dbałością o szczegóły, oparte o wiedzę
          anatomiczną, równoważą też one układ współczuły oraz przywspółczulny,
          dzięki czemu dają sto procent rezultatów na poziomie ciała oraz
          umysłu.
        </p>
      </section>
      <section class="whyItsWorth">
        <h2 class="sub-title">Dlaczego warto się zapisać</h2>
        <h3>Połączenie styli</h3>
        <p>
          Praktyka jogi połączona jest z nowoczesnymi metodami ćwiczeń
          funkcjonalnych i ćwiczeń wzmacniających.
        </p>

        <h3>Równowaga</h3>
        <p>
          Praktyka fizyczna prowadzona jest z naciskiem na poprawny oddech.
          Wplecione są też techniki oczyszczające oraz oddechowe, aby
          zrównoważyć układ przywspółczulny i współczulny.
        </p>

        <h3>Wybór</h3>
        <p>Samodzielnie wybierasz kiedy, i jaki temat chcesz praktykować</p>

        <h3>Strumieniowa Praktyka</h3>
        <p>
          Na każdym wideo demonstruje układy, motywując i wyjaśniając technikę.
        </p>

        <h3>Wiedza przekuta w praktykę</h3>
        <p>
          Mam bogate doświadczenie. Spędziłam wiele godzin na macie,
          merytorycznych warsztatach oraz kursach. Opanowanie poznanych technik,
          po połączeniu z podstawami anatomii pozwala mi tworzyć niepowtarzalne
          autorskie sekwencje.
        </p>

        <h3>Oko Mentora</h3>
        <p>
          Dla Subskrybentów został stworzony specjalny pokój na telegramie,
          gdzie można zadawać pytania, dzielić się swoimi efektami oraz
          otrzymywać moje porady i komentarze.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import GiftCard from "../components/GiftCard.vue";
export default {
  name: "GiftVouchers",
  components: {
    GiftCard,
  },
  async created() {
    await this.$store.dispatch(`giftCard/fetchGiftCards`);
  },
  computed: {
    giftCards() {
      return this.$store.getters["giftCard/getAllGiftCards"];
    },
  },
};
</script>

<style lang="scss" scoped>


.container {
  max-width: 2560px;
}

.gifts {
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
  h2 {
    font-size: 2.4rem;
    padding-bottom: 1.5rem;
    @media (max-width: 768px) {
      font-size: 2.1rem;
    }
    @media (max-width: 425px) {
      font-size: 1.7rem;
      text-align: center;
      padding-bottom: 1rem;
    }
  }
  .giftForSomeone {
    .card-container {
      display: flex;
      flex-direction: row;
      margin: auto;
      justify-content: center;
      margin-top: 50px;
      gap: 150px;
      @media (max-width: 1200px) {
        gap: 50px;
        flex-wrap: wrap;
      }
    }
  }

  .howItWorks,
  .whatGivesSubscription,
  .whyItsWorth {
    padding: 1rem 0;
    padding-left: 30px;
    color: #6d6963;
    @media (max-width: 768px) {
      padding: 2rem 0 3.5rem;
    }
  }
  .howItWorks h2,
  .whatGivesSubscription h2,
  .whyItsWorth h2 {
    text-align: left;
  }

  .howItWorks {
    li {
      font-size: 1.05rem;
      width: 78%;
      @media (max-width: 425px) {
        font-size: 0.95rem;
        width: 100%;
      }
    }
  }

  .whatGivesSubscription {
    p {
      font-size: 1.05rem;
      width: 78%;
      @media (max-width: 425px) {
        font-size: 0.95rem;
        width: 100%;
        text-align: justify;
      }
    }
  }

  .whyItsWorth {
    h3 {
      font-size: 1.4rem;
      @media (max-width: 768px) {
        font-size: 1.25rem;
      }
      @media (max-width: 425px) {
        font-size: 1.2rem;
      }
    }
    p {
      font-size: 1.05rem;
      width: 78%;
      @media (max-width: 425px) {
        font-size: 0.95rem;
        width: 100%;
        text-align: justify;
      }
    }
  }
}
</style>
